import { classnames } from 'tailwindcss-classnames';
import { Data } from '.generated/templates/Feature.Data.model';
import React from 'react';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import type { Graph } from 'schema-dts';
import sanitizeHtml from 'sanitize-html';
import Head from 'next/head';

export type PageSchemaProps = Sitecore.Override.ComponentBase & Data.Seo.Fields.PageSchema;
const PageSchema = ({ fields }: PageSchemaProps): React.JSX.Element => {
  const isExperienceEditor = useExperienceEditor();

  if (isExperienceEditor) {
    return (
      <div className={classnames('w-full', 'text-center')}>Click here to edit Page Schema</div>
    );
  }
  const pageSchemaJson: Graph = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'AboutPage',
        name: fields?.pageSchemaName?.value,
        alternateName: fields?.pageSchemaAlternateName?.value,
        url: fields?.pageSchemaUrl?.value,
        inLanguage: 'en-US',
        mainEntity: {
          '@type': 'Organization',
          name: fields?.mainEntityName?.value,
          url: fields?.mainEntityUrl?.value,
          logo: {
            '@type': 'ImageObject',
            url: 'https://www.nmdp.org/-/media/project/nmdp/global/images/logos/nmdp_logo_tm_300x96.svg',
          },
          sameAs: [
            'https://www.facebook.com/NMDP.org/',
            'https://x.com/NMDP',
            'https://www.linkedin.com/company/nmdp/',
          ],
          description: fields?.pageSchemaDescription?.value,
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+1-800-627-7692',
            contactType: 'Customer Service',
            areaServed: 'US',
            availableLanguage: ['English', 'Spanish'],
          },
        },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: '1',
              name: 'Home',
              item: 'https://www.nmdp.org/',
            },
            {
              '@type': 'ListItem',
              position: '2',
              name: 'What We Do',
              item: 'https://www.nmdp.org/what-we-do/',
            },
            {
              '@type': 'ListItem',
              position: '3',
              name: 'About Us',
              item: 'https://www.nmdp.org/what-we-do/about-us',
            },
          ],
        },
      },
    ],
  };
  const pageSchemaJsonString = sanitizeHtml(JSON.stringify(pageSchemaJson));
  const id = 'nmdp-seo-pageschema';
  return (
    <Head>
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: pageSchemaJsonString }}
        type="application/ld+json"
        key={id}
        id={id}
      />
    </Head>
  );
};

export default PageSchema;
